export const SALE_STATUS = {
  IN_PROGRESS: 1,
  APPROVED: 2,
  FAILED: 3,
  CANCELED: 4,
  EDITED: 5,
  CANCELLED_WITH_PIX: 6,
  EDITED_AND_APPROVED: 7,
  PENDING: 8,
} as const;

export const getSaleStatusColor = (statusId: number): string => {
  switch (statusId) {
    case SALE_STATUS.APPROVED:
      return "bg-green-50 hover:bg-green-100 border-l-4 border-green-500";
    case SALE_STATUS.CANCELED:
    case SALE_STATUS.CANCELLED_WITH_PIX:
    case SALE_STATUS.FAILED:
      return "bg-red-50 hover:bg-red-100 border-l-4 border-red-500";
    case SALE_STATUS.EDITED:
      return "bg-blue-50 hover:bg-blue-100 border-l-4 border-blue-500";
    case SALE_STATUS.IN_PROGRESS:
    default:
      return "hover:bg-zinc-100 dark:hover:bg-zinc-800";
  }
};

export const getSaleStatusBadge = (statusId: number): string => {
  switch (statusId) {
    case SALE_STATUS.APPROVED:
      return "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300";
    case SALE_STATUS.CANCELED:
    case SALE_STATUS.CANCELLED_WITH_PIX:
    case SALE_STATUS.FAILED:
      return "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300";
    case SALE_STATUS.EDITED:
      return "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300";
    case SALE_STATUS.IN_PROGRESS:
    default:
      return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300";
  }
};